import { Box, Flex, HStack, Image } from '@chakra-ui/react';
import { Heading } from 'ui-components';
import { useGetAgency } from '~/hooks/api/agencies/get';
import { MediaKit } from '~/hooks/api/media-kits/get';

import { ContactBtn } from './ContactBtn';

export const TopBar = ({ mediaKit }: { mediaKit: MediaKit }) => {
  const agency = useGetAgency(mediaKit.agency_id);

  return (
    <Flex
      paddingY={{
        base: 8,
        lg: 0,
      }}
      paddingX={{
        base: 6,
        lg: 0,
      }}
      paddingBottom={{
        base: 3,
        lg: 10,
      }}
      justifyContent="space-between"
      alignItems="center"
      wrap="wrap"
      overflow="hidden"
      gap={4}
    >
      <Flex
        justifyContent="center"
        flex={{
          base: 1,
          md: 'none',
        }}
      >
        <Image height="3rem" src={agency.data?.agencyLogo} />
      </Flex>

      <HStack
        alignItems="center"
        justifyContent="space-between"
        overflow="hidden"
        flexWrap="wrap"
        flex={{
          base: 'none',
          md: 1,
        }}
        width="100%"
      >
        <Box flex="1" minWidth={0}>
          <Heading
            size="md"
            sx={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
            color="var(--media-kit-text-base)"
          >
            {mediaKit.name}
          </Heading>
        </Box>

        <ContactBtn email={mediaKit.contact.manager_email} />
      </HStack>
    </Flex>
  );
};
